module.exports = __webpack_public_path__ + "img/yun_1.b6cd897b.png";